import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG, DATE_FORMAT_LONG_MINUTE } from 'CorePackage/MainModule/constants/dateFormat';
import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';

import { IErknmSuspensionEvent } from '../interfaces/IErknmSuspensionEvent';
import { parseErknmValue } from './parseErknmValue';

export const getSuspensionEvents = (
  passportData: IKnmPreview | undefined,
  erknmField: 'pmErknm' | 'inspectionErknm',
) => {
  const suspensionEvents: IErknmSuspensionEvent[] = [];
  passportData?.[erknmField]?.events?.forEach(item => {
    const eventValue = item.event?.value && parseErknmValue<{ title?: string }>(item.event.value);
    const addedSuspensionEvents: IErknmSuspensionEvent[] =
      item.suspension?.map(stopItem => ({
        ...stopItem,
        event: eventValue && eventValue.title,
        startDate: stopItem.startDate && formatDate({ date: stopItem.startDate, dateFormat: DATE_FORMAT_LONG }),
        stopDate: stopItem.stopDate && formatDate({ date: stopItem.stopDate, dateFormat: DATE_FORMAT_LONG }),
        decisionDateTime:
          stopItem.decisionDateTime &&
          formatDate({ date: stopItem.decisionDateTime, dateFormat: DATE_FORMAT_LONG_MINUTE }),
      })) || [];
    suspensionEvents.push(...addedSuspensionEvents);
  });
  suspensionEvents.sort((a, b) => {
    return a.dateCreate && b.dateCreate ? new Date(a.dateCreate).valueOf() - new Date(b.dateCreate).valueOf() : 0;
  });

  return suspensionEvents;
};
